import React, {useEffect, useMemo, useState} from 'react';
import useFetchData from 'js/hooks/useFetchData/useFetchData';
import DataValidator from 'js/components/Common/DataValidator/DataValidator';

import fetchData from './fetchData';
import classes from './Testimonials.module.pcss';
import Container from 'js/components/Common/Container/Container';
import Heading from 'js/components/Common/Heading/Heading';
import Swiper from 'react-id-swiper';
import parse from 'html-react-parser';

interface Props {
    pageId: number
}

type Testimonial = {
    description: string,
    author: string
}

const Testimonials = ({pageId}: Props) => {
    const [slider, setSlider] = useState(null);
    const [title, setTitle] = useState<string>('');
    const [testimonials, setTestimonials] = useState<Array<Testimonial>>(null);

    const {isLoading, error} = useFetchData({
        query: `${fetchData(pageId)}`,
        condition: !!pageId,
        updateData: (data: any): void => {
            const result = data?.page?.ServicesTemplate;
            setTitle(result?.titleTestimonials);
            setTestimonials(result?.testimonials);
        }
    });

    const params = useMemo(
        () => ({
            slidesPerView: 3,
            spaceBetween: 16,
            centeredSlides: true,
            speed: 500,
            loop: true,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false
            },
            getSwiper: setSlider
        }),
        []
    );

    useEffect(() => {
        const swiperContainer = document.querySelector(`.${classes.Testimonials} .swiper-container`);

        if (!swiperContainer || !slider) {
            return;
        }

        const handleMouseEnter = () => {
            slider.autoplay.stop();
        };

        const handleMouseLeave = () => {
            slider.autoplay.start();
        };

        swiperContainer.addEventListener('mouseenter', handleMouseEnter);
        swiperContainer.addEventListener('mouseleave', handleMouseLeave);

        return () => {
            swiperContainer.removeEventListener('mouseenter', handleMouseEnter);
            swiperContainer.removeEventListener('mouseleave', handleMouseLeave);
        };
    }, [slider]);

    return (
        <DataValidator data={!isLoading && !error && testimonials?.length > 0}>
            <section className={classes.Testimonials}>
                <Container>
                    <Heading text={title} />
                </Container>
                <Container additionalClass={classes.Wrapper}>
                    <div className={classes.Items}>
                        <Swiper {...params}>
                            {testimonials?.map((slide, index) => (
                                <div className={`${classes.Item} swiper-slide`} key={index}>
                                    <div className={classes.SlideWrap}>
                                        <div className={classes.Info}>
                                            <p>{parse(slide?.description || '')}</p>
                                        </div>
                                        <span className={classes.Author}>{slide?.author}</span>
                                    </div>
                                </div>
                            ))}
                        </Swiper>
                    </div>
                </Container>
            </section>
        </DataValidator>
    );
};

export default Testimonials;
